export default "__VITE_ASSET__YiGZwjo7__"